<template>
  <div class="NewEdit">
    <ul class="quadrados">
      <li />
      <li />
      <li />
      <li />
      <li />
    </ul>
    <div class="Editor">
      <el-form
        ref="postFormRef"
        :model="postForm"
        :rules="rules"
        status-icon
        hide-required-asterisk
        label-position="top"
        label-width="120px"
      >
        <el-form-item
          label="文章標題"
          prop="title"
        >
          <el-input
            v-model="postForm.title"
            autocomplete="off"
            placeholder="請輸入標題"
          />
        </el-form-item>
        <el-form-item
          label="文章內容"
          prop="content"
        >
          <el-input
            v-model="postForm.content"
            autocomplete="off"
            placeholder="請輸入文章內容，使用markdown語法更能格式化！"
            type="textarea"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="submitDisabled"
            @click="submitForm()"
          >
            送出文章
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
export default {
  name: 'Register',
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const postFormRef = ref(null)
    const submitDisabled = ref(false)
    const rules = {
      title: [{ required: true, message: '請輸入標題!', trigger: 'change' }],
      content: [{ required: true, message: '請輸入文章內容!', trigger: 'change' }]
    }
    const postForm = reactive({
      title: '',
      content: ''
    })
    function resetForm () {
      postFormRef.value.resetFields()
    }
    if (Object.keys(route.query).length !== 0) {
      postForm.title = route.params.editTitle
      postForm.content = route.params.editContent
    }
    function submitForm () {
      if (Object.keys(route.query).length !== 0) {
        editPost()
      } else {
        newPost()
      }
    }
    function newPost () {
      postFormRef.value.validate(valid => {
        if (!valid) {
          console.error('文章未填寫')
        } else {
          submitDisabled.value = true
          const body = {
            news_title: postForm.title,
            news_content: postForm.content
          }
          axios.post('https://api.guardian17681.com/news/post/add', body, { headers: { Authorization: 'Bearer ' + store.state.loginToken } })
            .then((response) => {
              console.log(response.data.status)
              ElMessage({
                message: '文章新增成功，跳轉中...',
                type: 'success'
              })
              setTimeout(() => {
                router.push({ name: 'News', params: { status: 'edited' } })
              }, 2000)
            })
            .catch((error) => {
              ElMessage.error('文章新增失敗，您未擁有新增文章的權限。')
              console.log(error)
              submitDisabled.value = false
            })
        }
      })
    }
    function editPost () {
      postFormRef.value.validate(valid => {
        if (!valid) {
          console.error('文章未填寫')
        } else {
          submitDisabled.value = true
          const body = {
            news_id: route.query.editId,
            news_title: postForm.title,
            news_content: postForm.content
          }
          axios.post('https://api.guardian17681.com/news/post/update', body, { headers: { Authorization: 'Bearer ' + store.state.loginToken } })
            .then((response) => {
              console.log(response.data.status)
              ElMessage({
                message: '文章編輯成功，跳轉中...',
                type: 'success'
              })
              setTimeout(() => {
                router.push({ name: 'News', params: { status: 'edited' } })
              }, 2000)
            })
            .catch((error) => {
              ElMessage.error('文章編輯失敗，您未擁有新增文章的權限。')
              console.log(error)
              submitDisabled.value = false
            })
        }
      })
    }
    return {
      postForm,
      postFormRef,
      resetForm,
      submitForm,
      submitDisabled,
      rules,
      newPost,
      editPost
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__label {
  color: white;
}
.quadrados {
  background: linear-gradient(#74afd1, #5c88a0);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}

.quadrados li {
  position: absolute;
  list-style: none;
  display: block;
  background-color: rgba(255, 255, 255, 0.15);
  bottom: -100px;
  -webkit-animation: square 20s infinite;
  animation: square 20s infinite;
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
}

.quadrados li:nth-child(1) {
  width: 40px;
  height: 40px;
  left: 20%;
}
.quadrados li:nth-child(2) {
  width: 60px;
  height: 60px;
  left: 40%;
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
  -webkit-animation-duration: 17s;
  animation-duration: 17s;
}

.quadrados li:nth-child(3) {
  width: 10px;
  height: 10px;
  left: 60%;
  -webkit-animation-delay: 4s;
  animation-delay: 4s;
  -webkit-animation-duration: 13s;
  animation-duration: 13s;
}

.quadrados li:nth-child(4) {
  width: 80px;
  height: 80px;
  left: 80%;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
  -webkit-animation-duration: 22s;
  animation-duration: 22s;
}

.quadrados li:nth-child(5) {
  width: 50px;
  height: 50px;
  left: 50%;
  -webkit-animation-delay: 7s;
  animation-delay: 7s;
  -webkit-animation-duration: 12s;
  animation-duration: 12s;
}

@-webkit-keyframes square {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-1080px) rotate(630deg);
    transform: translateY(-1080px) rotate(630deg);
  }
}

@keyframes square {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(-1080px) rotate(630deg);
    transform: translateY(-1080px) rotate(630deg);
  }
}
.fade-height-enter-active,
.fade-height-leave-active {
  transition: all 0.5s ease-out;
  max-height: 1000px;
}

.fade-height-enter-from,
.fade-height-leave-to {
  opacity: 0;
  max-height: 0px;
}

.el-link.el-link--primary {
  color: rgb(0, 174, 255);
  font-size: 16px;
  transition: 150ms;
  &:hover {
    filter: brightness(150%);
    transition: 150ms;
  }
}
$phones-media: 769px;
@media only screen and (max-width: $phones-media) {
  //手機版css
  .NewEdit {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #74afd1;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .login-container {
    width: 80vw;
    background-color: #c1dbeb4b;
    border: 1px solid #ffffff81;
    border-radius: 4px;
    padding: 15px;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
  }
}
@media only screen and (min-width: $phones-media) {
  //電腦版css
  .NewEdit {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #74afd1;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .Editor {
    width: 80vw;
    background-color: #c1dbeb4b;
    border: 1px solid #ffffff81;
    border-radius: 4px;
    padding: 15px;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
    margin-top: 60px
  }
  $inputFontSize: 16px;

  ::v-deep .el-textarea {
    textarea {
      padding: 7.5px 0 7.5px 8px; // changing the padding here can affect the height of the textarea
      font-size: $inputFontSize;
      min-height: 250px !important;
    }
  }
}
</style>
